import {
    SHORT_LINK_REQUESTED,
    SHORT_LINK_SUCCEEDED,
    SHORT_LINK_FAILED,
} from './actions';

const initialState = {
    loading: false,
    ogTitle: null,
    ogDescription: null,
    ogImage: null,
    errors: [],
};

export default function shortLinksReducer(state = initialState, action) {
    const { type, payload = {} } = action;
    if (type === SHORT_LINK_REQUESTED) {
        return {
            ...state,
            loading: true,
            ogTitle: null,
            ogDescription: null,
            ogImage: null,
            errors: [],
        };
    } else if (type === SHORT_LINK_SUCCEEDED) {
        return {
            ...state,
            loading: false,
            ogTitle: payload.ogTitle,
            ogDescription: payload.ogDescription,
            ogImage: payload.ogImage,
            errors: [],
        };
    } else if (type === SHORT_LINK_FAILED) {
        return {
            ...state,
            loading: false,
            ogTitle: null,
            ogDescription: null,
            ogImage: null,
            errors: payload.errors,
        };
    }
    return state;
}
